import Textarea from "@/components/common/Textarea.vue";
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import message from "@/components/common/message/Message.vue";
import moment from "moment/moment.js";

const defaultEl = {
    client_id: null,
    amount_debt: null,
    comment: null
}

export default {
    name: 'AddComment',

    components: {
        message,
        Textarea
    },

    setup: () => ({ v$: useVuelidate() }),
    data () {
        return {
            form: defaultEl,
            isVisibleMsg: false,
            message: null,
            loading: false,
            list: [],
        }
    },

    validations () {
        return {
            form: {
                comment: { required },
            }
        }
    },

    methods: {
        async show(client_id, amount_debt) {
            this.v$.$reset();
            this.form = this.BasicHelper.cloneObject(defaultEl);
            this.form.client_id = client_id;
            this.form.amount_debt = amount_debt;
            this.loading = true;
            try {
                const { data } = await this.ApiRequest.requestAsync(
                    `billing/debtors/comment/history/${client_id}`,
                    this.ApiRequest.REQUEST_GET,
                    [],
                    `debtors-comment-${client_id}`,
                    true
                );
                if (data) {
                    this.list = data.comment;
                }
                this.$refs['modal-window'].show();
            } finally {
                this.loading = false;
            }
        },

        formatDate(date) {
            return moment(date).format('DD.MM.YYYY')
        },

        async submit() {
            const isFormCorrect = await this.v$.$validate();
            if (!isFormCorrect) return;
            this.loading = true;
            try {
                const { data } = await this.ApiRequest.requestAsync(
                    `billing/debtors/comment/store`,
                    this.ApiRequest.REQUEST_POST,
                    this.form,
                    'debtors-comment-store',
                    true
                );

                if (!data) return;
                this.list = data.comment;
                this.form.comment = '';
                this.v$.$reset();
                this.isVisibleMsg = true;
                this.message = this.$t('debtors.comment.store_successfully');
            } finally {
                this.loading = false;
            }
        },

        changeIsVisibleMsg(isVisible) {
            this.isVisibleMsg = isVisible;
        },

        close () {
            this.$refs['modal-window'].hide();
        }
    }
}